import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { WebAdmin } from '../models/WebAdmin'
import { upsertMultipleWebAdmins } from '../webAdminsSlice'

export const fetchWebAdmins = createAsyncThunk('webAdmins/fetch', async (_, { dispatch }) => {
  const webAdmins = await OLMSApiService.get<WebAdmin[]>('/webadmin/list')

  if (webAdmins && webAdmins.length > 0) {
    dispatch(upsertMultipleWebAdmins(webAdmins))
  }
})
